import { render, staticRenderFns } from "./check-the-details.vue?vue&type=template&id=b51dd766"
import script from "./check-the-details.vue?vue&type=script&lang=js"
export * from "./check-the-details.vue?vue&type=script&lang=js"
import style0 from "./check-the-details.vue?vue&type=style&index=0&id=b51dd766&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports